import { cva } from 'class-variance-authority';

// Permanent grab-handle pill in brand teal (secondary token). Pseudo-element
// `before` is the pill, `after` is the faint guide line spanning the divider.
export const resizableAsideHandleVariants = cva(
  [
    'relative shrink-0 bg-transparent transition-colors duration-150',
    'after:content-[""] after:absolute after:rounded-[1px] after:bg-neutral-border',
    'after:transition-colors after:duration-150',
    'before:content-[""] before:absolute before:top-1/2 before:left-1/2',
    'before:rounded-[3px] before:bg-neutral-border',
    'before:transition before:duration-150',
    'before:-translate-x-1/2 before:-translate-y-1/2 before:z-[1]',
    'hover:after:bg-secondary focus-visible:after:bg-secondary',
    'hover:before:bg-secondary focus-visible:before:bg-secondary',
    'hover:before:shadow-[0_0_0_2px_oklch(var(--secondary)/0.3)]',
    'focus-visible:before:shadow-[0_0_0_2px_oklch(var(--secondary)/0.3)]',
    'focus-visible:outline-none',
  ].join(' '),
  {
    variants: {
      orientation: {
        vertical: [
          'w-2 self-stretch cursor-col-resize',
          'after:inset-y-0 after:left-1/2 after:w-[0.5px] after:-translate-x-1/2',
          'before:w-[5px] before:h-[100px] before:max-h-[60%]',
        ].join(' '),
        horizontal: [
          'h-2 w-full cursor-pointer',
          'after:inset-x-0 after:top-1/2 after:h-[0.5px] after:-translate-y-1/2',
          'before:h-[5px] before:w-[100px] before:max-w-[60%]',
        ].join(' '),
      },
    },
    defaultVariants: {
      orientation: 'vertical',
    },
  }
);
